import { useController } from "react-hook-form";
import LevelSelect from "../../components/LevelSelect";
import { cn } from "../../../../../../../../../lib/utils";

function LevelController({ control, name, group, disabled }: any) {
    const { field, fieldState } = useController({
        control,
        name,
        shouldUnregister: false,
    });

    return (
        <LevelSelect
            className={cn(
                "tw-w-full",
                fieldState.error?.message && "tw-border-red-500 focus-visible:tw-border-red-500 focus-visible:tw-ring-red-500/20"
            )}
            placeholder={group.description}
            value={field.value}
            group={group.id}
            allowClear={!group.isRequired}
            filterName={group.level.replaceAll("_", "")}
            onChange={field.onChange}
            disabled={disabled}
        />
    );
}

export default LevelController;
